import React from 'react';
import { HelpNavigationButton } from 'design-system';
import useHelpActionSheet from 'hooks/useHelpActionSheet';
import Links from 'utils/links';
const OPTS = {
    showVisitHelpCentre: true,
    additionalOptions: [
        {
            title: 'Why do I need to select?',
            onPress: () => {
                Links.openKnownLink('whyDoINeedToSelectLogins');
            },
        },
    ],
};
const LoginsUpgradeHelpButton = ({ black }) => {
    const showHelpActionSheet = useHelpActionSheet(OPTS);
    return <HelpNavigationButton black={black} onPress={showHelpActionSheet}/>;
};
export default LoginsUpgradeHelpButton;
